import { gql } from '@apollo/client';

export default gql`
  mutation addExternalReference($reference: String!, $externalReference: ExternalReferenceInput!) {
    addExternalReference(reference: $reference, externalReference: $externalReference) {
      reference
    }
  }
`;
